import { BaseModel } from 'app/core/_base/crud';
    export class NotificationModel extends BaseModel {
		NgayGui:string
		NguoiGui:string
		TenNguoiGui:string
		NoiDung:string
		Loai:number
		LinkPhieu:string
		Id:number
		TrangThai:number
		Time: string

		clear(){
			this.NgayGui = ''
			this.NguoiGui = ''
			this.TenNguoiGui  = ''
			this.NoiDung = ''
			this.Loai = 0
			this.LinkPhieu = ''
			this.Id = 0
			this.TrangThai = 0
			this.Time = ''
		}

		copy(item: NotificationModel){
			this.NgayGui = item.NgayGui
			this.NguoiGui = item.NguoiGui
			this.TenNguoiGui  = item.TenNguoiGui
			this.NoiDung = item.NoiDung
			this.Loai = item.Loai
			this.LinkPhieu = item.LinkPhieu
			this.Id = item.Id
			this.TrangThai = item.TrangThai
			this.Time = item.Time
		}
    }
